export default __webpack_public_path__ + "locales/hy-AM/DeleteThirdPartyDialog.json?hash=0847393b081407899c3fa30d560b32ce";